import { cx } from './ui';

/**
 * The mark: a clapperboard. Hard rule, three diagonal chalk strokes, and a
 * single red lamp that is the only saturated pixel in the product's chrome.
 */
export function ClapperMark({ size = 24, lit = false }: { size?: number; lit?: boolean }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <rect x="2" y="4" width="28" height="24" rx="3" className="fill-slate-800" />
      <path d="M2 12h28v2H2z" className="fill-chalk" opacity="0.9" />
      <path
        d="M6.5 4.5l3 6.5H5.2l-3-6.5zM13.5 4.5l3 6.5h-4.3l-3-6.5zM20.5 4.5l3 6.5h-4.3l-3-6.5zM27.5 4.5l2.5 5.4V11h-1.8l-3-6.5z"
        className="fill-chalk"
        opacity="0.85"
      />
      <circle
        cx="8"
        cy="21"
        r="2.5"
        className={cx(lit ? 'fill-record' : 'fill-slate-600')}
      />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cx('flex items-center gap-2', className)}>
      <ClapperMark size={22} />
      <span className="text-h4 font-semibold tracking-[-0.02em] text-chalk">Slate</span>
    </span>
  );
}

/** The chalk-stripe rule. Decorative only. */
export function ClapperRule({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cx('clapper-stripes h-[3px] w-full opacity-[0.12]', className)}
    />
  );
}
